export const convertValue = (value: number, rate: number) => (value / rate);